import { Button, Flex, Heading, Image, Stack, Text, useBreakpointValue } from '@chakra-ui/react';
import { BLUE, BLUE_LIGHTER, IVORY } from 'constants/colors';

const UnderConstruction = () => {
  return (
    <Stack height="calc(100vh - 74px)" direction={{ base: 'column', md: 'row' }}>
      <Flex p={8} flex={1} align={'center'} justify={'center'}>
        <Stack spacing={6} w={'full'} maxW={'lg'}>
          <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
            <Text
              as={'span'}
              position={'relative'}
              _after={{
                content: "''",
                width: 'full',
                height: useBreakpointValue({ base: '20%', md: '30%' }),
                position: 'absolute',
                bottom: 1,
                left: 0,
                bg: IVORY,
                zIndex: -1,
              }}
            >
              Dalam Proses
            </Text>
            <br />{' '}
            <Text color={BLUE} as={'span'}>
              Pengerjaan
            </Text>{' '}
          </Heading>
          <Text fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            Maaf, halaman yang anda tuju masih dalam proses pengerjaan.
          </Text>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Button
              rounded={'full'}
              bg={BLUE}
              color={'white'}
              _hover={{
                bg: BLUE_LIGHTER,
              }}
            >
              Kembali ke Beranda
            </Button>
          </Stack>
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Image
          alt={'Login Image'}
          objectFit={'cover'}
          padding={10}
          maxH={useBreakpointValue({ base: '400px', md: 'auto' })}
          width="100%"
          src={'https://images.pexels.com/photos/4065864/pexels-photo-4065864.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'}
        />
      </Flex>
    </Stack>
  );
};

export default UnderConstruction;
